import { render, staticRenderFns } from "./editMenuModel.vue?vue&type=template&id=c519f052&scoped=true"
import script from "./editMenuModel.vue?vue&type=script&lang=js"
export * from "./editMenuModel.vue?vue&type=script&lang=js"
import style0 from "./editMenuModel.vue?vue&type=style&index=0&id=c519f052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c519f052",
  null
  
)

export default component.exports